import { Component, } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoDataFoundComponent } from '../../../shared/components/no-data-found/no-data-found.component';
import { RouterModule } from '@angular/router';
import { BaseComponent } from '../../../core/components/base.component';
import { ButtonComponent } from '../../../shared/forms/components/button/button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'berry-error',
  standalone: true,
  imports: [CommonModule, NoDataFoundComponent, RouterModule, ButtonComponent,TranslateModule],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss'
})
export class ErrorComponent extends BaseComponent {
  record: any = { title: 'no_results_Contacts_Search', message: 'DontHavePermmission_Common',statusCode:'404' }
 
 
  constructor() {
    super();

    this._route.params.subscribe((res) => {
        
      this.record = {...this.record,...res};
      
    })

  }

  protected override ngSuperOnInit() {
    this._sidebarService.sideBarVisibility.set(false);
    this._sidebarService.clearSideBarData();
  }
  
  senToSupportTeam():void{
      const supportUrlEmails = this._appData.configurations.supportTeam;
      window.location.href = 'mailto:'+ supportUrlEmails;
  }

  goBack():void{
    this._router.navigateByUrl(this._layoutService['layoutDic'].get('GetMainApplicationLayout').landingUrl)
  }

  protected override ngSuperAfterViewInit() {
  }
  protected override ngSuperOnDestroy() {
  }

}
